import { Injectable } from '@angular/core';
import { AuthAssetsService } from './auth-assets.service';
import { CanActivate, Router } from '@angular/router';
import { RoutesPath } from '../../routes-path';

@Injectable()
export class FirstVisitGuardService implements CanActivate {
  constructor(public authAssets: AuthAssetsService, public router: Router) {}

  canActivate(): boolean {
    //WARNING uncomment this to have welcome Page
    // if (!this.authAssets.isFirstVisit()) {
    this.router.navigate([RoutesPath.default.home]);
    return false;
    // }
    return true;
  }
}
